import React from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';
import InputSelectComponent, {
  type Props,
  OptionProps,
} from '../../styled-components/components/InputSelect';

export { OptionProps };

type InputSelectProps = Props & {
  register: UseFormRegisterReturn;
};
const InputSelect = ({ id, ...props }: Omit<InputSelectProps, 'ref'>) => {
  return <InputSelectComponent id={id || `id-${props.register.name}`} {...props} />;
};

export default InputSelect;
